<template>
  <div class="flex justify-center items-center">
    <div
      class="loader border-4 border-grey-lightest w-8 h-8 rounded-full animate-spin"
    ></div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "LoadingSpinner",
});
</script>

<style>
.loader {
  border-top-color: #d0a97e;
}
</style>
